import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';

import rootReducer from './rootReducer';
import { localStorageMiddleware } from './middleware';

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(localStorageMiddleware),
});

type StateProperties = ReturnType<typeof store.getState>;

export type DispatchProperties = typeof store.dispatch;
export const useSelector: TypedUseSelectorHook<StateProperties> = useReduxSelector;

export default store;
